import addSeconds from 'date-fns/addSeconds';
import format from 'date-fns/format';

export const convertVideoDuration = (
	durationInSeconds?: number,
	options?: { readable?: boolean },
) => {
	if (durationInSeconds === undefined) {
		return null;
	}

	const date = addSeconds(new Date(0), durationInSeconds);

	const ONE_HOUR = 3600;
	const ONE_MINUTE = 60;

	const hours = Math.floor(durationInSeconds / ONE_HOUR);
	const minutes = Math.floor((durationInSeconds % ONE_HOUR) / ONE_MINUTE);
	const seconds = durationInSeconds % ONE_MINUTE;

	if (options?.readable) {
		if (durationInSeconds < ONE_MINUTE) {
			return `${seconds} sec`;
		} else if (durationInSeconds < 3600) {
			return `${minutes} min`;
		} else {
			return `${hours} hour ${minutes} min`;
		}
	}

	if (durationInSeconds < ONE_HOUR) {
		return format(date, 'mm:ss');
	}

	return format(date, 'HH:mm:ss');
};

export const isLoomUrlExpired = (url: string) => {
	const urlParams = new URLSearchParams(new URL(url).search);
	const base64Policy = urlParams.get('Policy');

	if (!base64Policy) {
		return true;
	}
	const decodedPolicy = Buffer.from(base64Policy, 'base64').toString('utf-8');
	const i = decodedPolicy.lastIndexOf('}');
	const sanitizedPolicy = decodedPolicy.substring(0, i + 1);
	let policy;
	try {
		policy = JSON.parse(sanitizedPolicy);
	} catch (_) {
		return true;
	}

	if (policy.Statement && policy.Statement.length > 0) {
		const statement = policy.Statement[0];
		if (statement.Condition && statement.Condition.DateLessThan) {
			const epochTime = statement.Condition.DateLessThan['AWS:EpochTime'];
			const currentTime = Math.floor(Date.now() / 1000);
			return currentTime > epochTime;
		}
	}
	//fallthrough treat as expired
	return true;
};

export const createChapterUrl = (baseUrl?: string, durationInSeconds?: number) => {
	return `${baseUrl}?t=${durationInSeconds}`;
};
